import React, { Component } from 'react';
import JsonapiClient from '@holidayextras/jsonapi-client';
import _ from 'lodash';
import { authService } from '../../../utils/auth-service';

const EVENT_TYPES = {
  INFLUENCER_CREATED: 'influencerLink_created',
  USER_CREATED: 'users_created',
  CAMPAIGN_CREATED: 'campaigns_created',
  SHORTLIST_CREATED: 'shortlists_created',
  CAMPAIGN_SCANNED: 'campaign_scan',
  TRACKED_ASSED_CREATED: 'trackedAssets_created',
  CAMPAIGN_PERMISSION_CREATED: 'campaignPermission_created',
  CAMPAIGN_INVITATION_CREATED: 'campaignInvitation_created',
  CAMPAIGN_INVITATION_UPDATED: 'campaignInvitation_updated',
  ALL: 'all',
};

const withDyzioEventsData = WrapperComponent => class HasJSONAPIClient extends Component {
  constructor(props) {
    super(props);
    this.jsonAPIClient = new JsonapiClient(process.env.REACT_APP_API_BASE_URL, {
      header: {
        Authorization: `Bearer ${authService.getToken()}`,
      },
    });
  }

  getDyzioEvents = params => this.jsonAPIClient.find('dyzioevents', {
    sort: '-createdDate',
    ...params,
  }).then(response => {
    const json = _.map(response, item => item.toJSON());
    return json;
  });

  render() {
    return (
      <WrapperComponent
        {...this.props}
        getDyzioEvents={this.getDyzioEvents}
      />
    );
  }
};

module.exports = {
  withDyzioEventsData,
  EVENT_TYPES,
};



/** WEBPACK FOOTER **
 ** ./src/hocs/data/with-dyzio-events-data/index.js
 **/